import moment from "moment";

export const DEFAULT_START_DAY_HOUR = 7;
export const DEFAULT_END_DAY_HOUR = 20;
export const computeDifferenceBetweenDates = (startDate = moment(), endDate = moment()) => {
  return moment(endDate).diff(moment(startDate), "minutes");
};

export const convertMinutesToString = (minutes = 0) => {
  return Math.floor(minutes / 60) + "h" + (minutes % 60 < 10 ? "0" : "") + (minutes % 60);
};

export const displayFromMinutesDuration = (startDate = moment(), endDate = moment()) => {
  return convertMinutesToString(computeDifferenceBetweenDates(startDate, endDate));
};
export const displayDurationTrip = (startDate = moment(), endDate = moment()) => {
  return `${moment(startDate).format("HH[h]mm")} - ${moment(endDate).format("HH[h]mm")} (${convertMinutesToString(
    computeDifferenceBetweenDates(startDate, endDate)
  )})`;
};

export const computePercentage = (value, total) => {
  return total ? `${((value * 100) / total).toFixed(2)}%` : "N/C";
};

const getHour = date => {
  return moment(date).hour();
};
export const computeGridEnds = (activities = [[]]) => {
  const flattenActivities = activities.flat().filter(e => e);
  return flattenActivities.reduce(
    (acc, cur) => {
      const currentBegin = getHour(cur.start_date);
      const currentEnd = getHour(cur.end_date);
      if (currentBegin < DEFAULT_START_DAY_HOUR) acc.begin = currentBegin;
      if (currentEnd > DEFAULT_END_DAY_HOUR) acc.end = currentEnd;
      return acc;
    },
    { begin: DEFAULT_START_DAY_HOUR, end: DEFAULT_END_DAY_HOUR }
  );
};
const addDurationToRange = ({ rangeDate, sign = 1, period = "days" }) => {
  const startDate = rangeDate[0];
  const endDate = rangeDate[1];
  const startOf = period === "days" ? "day" : "month" ? "month" : "year";
  return [
    moment(startDate)
      .add(sign, period)
      .startOf(startOf),
    moment(endDate)
      .add(sign, period)
      .endOf(startOf)
  ];
};

export const addOneYear = rangeDate => {
  return addDurationToRange({ rangeDate, period: "years" });
};

export const removeOneYear = rangeDate => {
  return addDurationToRange({ rangeDate, sign: -1, period: "years" });
};

export const addOneMonth = rangeDate => {
  return addDurationToRange({ rangeDate, period: "months" });
};

export const removeOneMonth = rangeDate => {
  return addDurationToRange({ rangeDate, sign: -1, period: "months" });
};

export const addOneWeek = rangeDate => {
  return addDurationToRange({ rangeDate, period: "weeks" });
};

export const removeOneWeek = rangeDate => {
  return addDurationToRange({ rangeDate, sign: -1, period: "weeks" });
};



// WEBPACK FOOTER //
// src/modules/presence/utils/date.utils.js